import { HTMLInputTypeAttribute, FC, useCallback } from 'react';

import { useForm } from 'react-hook-form';

import { Form } from '@ui-furniture/common/form';
import {
  Label,
  InputBorder,
  ErrorMessage,
} from '@ui-furniture/common/form/common';
import { inputContentCss } from '@ui-furniture/css/input-content-css';
import { Button, HStack } from '@ui-furniture/elements';
import { FormInput } from '@ui-furniture/lib/form';
import { useFocusByIdOnMount } from '@ui-furniture/lib/hooks/use-focus-by-id-on-mount';
import { x } from '@ui-furniture/style';
import { InputPrependContainer } from '@ui-furniture/ui/input-prepend-container';

export type TextChatInputConfig = {
  prefix?: string;
  placeholder?: string;
  defaultValue?: string;
  buttonText?: string;
  inputType?: HTMLInputTypeAttribute;
};

export const TextChatInput: FC<{
  onAnswer: (value: string) => void;
  config: TextChatInputConfig;
}> = ({
  onAnswer,
  config: {
    prefix,
    placeholder,
    defaultValue,
    inputType = 'text',
    buttonText = 'Send',
  },
}) => {
  const form = useForm();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form;
  const onSubmit = useCallback(({ value: answer }) => {
    onAnswer(answer);
  }, []);
  const focusId = useFocusByIdOnMount();

  return (
    <Form form={form} onSubmit={handleSubmit(onSubmit)}>
      <FormInput error={errors.root?.message}>
        <Label>
          <ErrorMessage />
          {/* <LabelText>{label}</LabelText> */}
          <InputBorder>
            <HStack w='100%' spacing='0'>
              {prefix ? (
                <InputPrependContainer>{prefix}</InputPrependContainer>
              ) : null}
              <x.input
                id={focusId}
                {...inputContentCss}
                {...(prefix ? { pl: '0' } : {})}
                flex={1}
                placeholder={placeholder}
                type={inputType}
                defaultValue={defaultValue}
                {...register('value', {
                  required: 'Please answer the question',
                })}
              />
              <Button type='submit' variant='outline'>
                {buttonText}
              </Button>
            </HStack>
          </InputBorder>
        </Label>
      </FormInput>
    </Form>
  );
};
